import { IService } from '../interface/service';
export class Service implements IService{
    constructor(public ServiceId : number,public ServiceName : string,public SpecializeId : number){
        
    }
}



// WEBPACK FOOTER //
// ./src/app/section/master/model/service.ts